/* eslint-disable import/prefer-default-export */
import { styled } from '@mui/material/styles';

export const ShowMoreText = styled('b')`
	color: ${({ theme }) => theme.palette.primary.main};
	font-weight: 600;
	display: inline-block;
	cursor: pointer;
`;
